import { useState } from "react";
import { faqs } from "@/mocks/chigua";

export default function Faq() {
  const [openIdx, setOpenIdx] = useState(0);

  return (
    <section id="faq" className="container-page py-12 md:py-16">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-12 lg:gap-12">
        <div className="lg:col-span-4">
          <p className="flex items-center gap-2 text-xs font-semibold uppercase tracking-[0.25em] text-primary-600">
            <i className="ri-question-answer-line"></i>
            FAQ
          </p>
          <h2 className="section-title mt-3">常见问题答疑</h2>
          <p className="mt-4 text-sm leading-relaxed text-foreground-600">
            关于更新频率、热榜来源、投稿与转载的疑问，这里一次性说清楚，读报更顺手。
          </p>
          <a href="mailto:hello@chigua-daily.example" className="btn-ghost mt-6">
            <i className="ri-mail-line"></i>
            还有疑问？写邮件
          </a>
        </div>

        <div className="lg:col-span-8">
          <div className="divide-y divide-background-200 overflow-hidden rounded-2xl border border-background-200 bg-background-100">
            {faqs.map((f, i) => {
              const open = openIdx === i;
              return (
                <div key={f.q}>
                  <button
                    onClick={() => setOpenIdx(open ? -1 : i)}
                    aria-expanded={open}
                    className="flex w-full items-center justify-between gap-4 px-5 py-4 text-left md:px-6"
                  >
                    <span className="flex items-center gap-3">
                      <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full text-xs font-bold ${open ? "bg-accent-500 text-background-50" : "bg-secondary-100 text-secondary-800"}`}>
                        {String(i + 1).padStart(2, "0")}
                      </span>
                      <h3 className="text-[15px] font-semibold text-foreground-900">{f.q}</h3>
                    </span>
                    <i className={`shrink-0 text-lg text-foreground-500 transition ${open ? "rotate-45 text-accent-600" : ""} ri-add-line`}></i>
                  </button>
                  {open && (
                    <p className="px-5 pb-5 pl-[4.75rem] text-sm leading-relaxed text-foreground-600 md:px-6 md:pl-[4.75rem]">
                      {f.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}